import { render, staticRenderFns } from "./CookieDisabled.vue?vue&type=template&id=b9d6cd7c&scoped=true"
import script from "./CookieDisabled.vue?vue&type=script&lang=ts"
export * from "./CookieDisabled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d6cd7c",
  null
  
)

export default component.exports